import { createSlice } from "@reduxjs/toolkit"
import { sterilizationCitizenCallFormObject } from "@form/sterilizationCitizenCallFormFields"
import { sterilizationCompanyCallFormObject } from "@form/sterilizationCompanyCallFormFields"

const sterilizationSlice = createSlice({
  name: 'sterilization',
  initialState: {
    calls: {},
    seasonsScansData: null,
    viewedCalls: {},
    activeRowCall: null,
    filters: null,
    activeFilters: { districts: null, nbNests: null, callTypes: null, scanPhotosNests: null, scanPhotosBirds: null, scanPhotosEggs: null },
    sterilizationCitizenCallFormObject: { ...sterilizationCitizenCallFormObject },
    sterilizationCompanyCallFormObject: { ...sterilizationCompanyCallFormObject },
    sterilizationCompanyCallBuildings: [],
    sterilizationOrder: null,
    paymentForms: null,
    paymentPage: null,
    errors: [],
    callsScanPhotos: {},
    selectedCalls: null,
    selectedSeason: null
  },
  reducers: {
    fullUpdate: (state, action) => {
      return { ...state, ...action.payload }
    },
    clearSterilizationCallForm: (state) => {
      return { ...state, sterilizationCitizenCallFormObject, sterilizationCompanyCallFormObject }
    },
    updateSterilizationCallFormObject: (state, action) => {
      state.sterilizationCitizenCallFormObject = action.payload
    },
    updateSterilizationCompanyCallFormObject: (state, action) => {
      state.sterilizationCompanyCallFormObject = action.payload
    },
    updateSterilizationCompanyCallBuildings: (state, action) => {
      state.sterilizationCompanyCallBuildings = action.payload
    },
    updateSterilizationCalls: (state, action) => {
      state.calls = action.payload
    },
    updateSelectedCalls: (state, action) => {
      state.selectedCalls = action.payload
    },
    addSterilizationCall: (state, action) => {
      const call = action.payload
      state.calls = { ...state.calls, [call.id]: call }
    },
    updateSterilizationCall: (state, action) => {
      const { callUpdate, selectedSeason } = action.payload
      state.calls[selectedSeason] = { ...state.calls[selectedSeason], [callUpdate.id]: callUpdate }
    },
    updateSterilizationPayment: (state, action) => {
      return { ...state, ...action.payload }
    },
    updateActiveRowCall: (state, action) => {
      state.activeRowCall = action.payload
    },
    updateCallsScanPhotos: (state, action) => {
      state.callsScanPhotos = { ...state.callsScanPhotos, ...action.payload }
    },
    addSterilizationCalls: (state, action) => {
      state.calls = { ...state.calls, ...action.payload }
    },
    addViewedSterilizationCall: (state, action) => {
      const call = action.payload
      state.viewedCalls = { ...state.viewedCalls, [call.id]: call }
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    },
    updateFilters: (state, action) => {
      state.activeFilters = action.payload
    },
    selectSeason: (state, action) => {
      state.selectedSeason = action.payload
    }
  }
})

export const {
  clearSterilizationCallForm,
  updateSterilizationCallFormObject,
  updateSterilizationCompanyCallFormObject,
  addSterilizationCall,
  addSterilizationCalls,
  addViewedSterilizationCall,
  fullUpdate,
  updateSterilizationCalls,
  updateSterilizationCall,
  updateSterilizationPayment,
  updateErrors,
  updateFilters,
  updateActiveRowCall,
  updateSterilizationCompanyCallBuildings,
  updateCallsScanPhotos,
  updateSelectedCalls,
  selectSeason
} = sterilizationSlice.actions

export default sterilizationSlice.reducer